<!-- One search result (vehicle brands). Rendered by app-search inside the
     header's results panel, so it has to read at any width: photo | details |
     price + actions, stacking below 560px. -->
<article
  class="sc ui-card"
  role="link"
  tabindex="0"
  [attr.aria-label]="'View ' + product.ProductCategory + ' ' + product.ProductSubCategoryTitle"
  (click)="openUrl()"
  (keydown.enter)="openUrl()"
>
  <div class="sc__media">
    <span class="sc__noimg" aria-hidden="true"><svg class="cl-ico cl-ico--moke-nodel" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 17H3.5v-4.5L5.5 7.5h13l2 5V17H19M3.5 12.5h17"/><circle cx="7.5" cy="17" r="2"/><circle cx="16.5" cy="17" r="2"/><path d="M9.5 17h5"/></svg></span>
    <img
      [src]="product.ProductImageUrl"
      [alt]="product.ProductTitle"
      class="sc__img"
      (error)="$any($event.target).classList.add('is-broken')"
      [class.is-sold]="product.ProductStockStatus == 'Sold'"
    />
    <span *ngIf="product.ProductStockStatus == 'Sold'" class="sc__sold">Sold</span>
  </div>

  <div class="sc__body">
    <h3 class="sc__title">
      {{ product.ProductCategory }} {{ product.ProductSubCategoryTitle }}
      {{ product.ProductTitle }}
    </h3>
    <p class="sc__label" *ngIf="product.ProductLabel">{{ product.ProductLabel }}</p>
    <ul class="sc__facts">
      <ng-container *ngFor="let item of product.ProductExtraObject?.KeyFacts | keyvalue">
        <li *ngIf="item.value && item.value != '-1'" class="ui-tag">
          {{ item.key }}: {{ item.value }}
        </li>
      </ng-container>
    </ul>
  </div>

  <div class="sc__side">
    <div class="sc__price">
      {{ product.ProductNewPrice | currency: CurrencySymbol : "symbol" : "1.2-2" }}
    </div>
    <button type="button" class="ui-btn sc__btn" (click)="$event.stopPropagation(); openUrl()">
      More info
    </button>
    <button
      type="button"
      class="ui-btn ui-btn--ghost sc__btn"
      *ngIf="product.ProductStockStatus == 'Available'"
      (click)="$event.stopPropagation(); enquireNow()"
    >
      Enquire now
    </button>
  </div>
</article>
